<div class="d-flex flex-row">
  <div>
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column w-100">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    <!-- !!Loading animation -->
    @if (isLoading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <div class="w-100 d-flex flex-column justify-content-start">
          @if (isMedia) {
            <div>
              <h2>Importação de Ficheiros</h2>
              <button class="btn-processar" (click)="processar()" [disabled]="isLoading">
                <span>Processar</span>
                <img src="../../../../assets/Icons/check-line.png" alt="Check">
              </button>
              <hr>
                <div class="mt-4">
                  <p>Fazer upload de ficheiros ('.bl.pdf', '.fl.pdf', '.01.jpg', '.01.png', 'banner_').</p>
                  <div class="d-flex">
                    <input class="upload-input" type="file" multiple accept="image/*, .pdf"
                      (change)="onFileSelected($event)" />
                      <button [disabled]="selectedFiles.length <= 0" class="btn-processar ml-2"
                        (click)="uploadFiles()"><span>Enviar Ficheiros</span></button>
                      </div>
                    </div>
                  </div>
                }
                @if (!isMedia) {
                  <div>
                    <h2>Importação de Stock</h2>
                    <button class="btn-processar" (click)="stockProcessar()" [disabled]="isLoading">
                      <span>Processar</span>
                      <img src="../../../../assets/Icons/check-line.png" alt="Check">
                    </button>
                  </div>
                }
                <!--*MEDIA-->
                @if (!isLoading && data) {
                  @if (data.length > 0 && data[0].statusCode === 200) {
                    <div>
                      <h2 class="mt-4">Resultado:</h2>
                      <div class="response-container">
                        @for (file of data; track file) {
                          <div class="file-container">
                            <div class="file-info d-flex">
                              <p>{{file.filename }}
                                @if (file.isDuplicate) {
                                  <span style="color: var(--error-200)">- Duplicado -</span>
                                }
                                @if (file.movedTo) {
                                  <span>&nbsp;importado com êxito. </span>
                                }
                                @if (file.message) {
                                  <span>&nbsp; - {{file.message}}</span>
                                }
                              </p>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
                <!--*STOCK-->
                @if (!isLoading && stockData) {
                  @if (stockData.length > 0 && stockData[0].statusCode === 200) {
                    <div>
                      <h2 class="mt-4">Resultado:</h2>
                      <div class="response-container">
                        @for (file of stockData; track file) {
                          <div class="file-container">
                            <div class="file-info">
                              @if (!file.messageError) {
                                <p>Produto #{{file.reference}} - Stock Atualizado
                                para {{file.stockQtd}}</p>
                              }
                              @if (file.messageError) {
                                <p>Produto #{{file.reference}} - <span>Não existe na
                                base de dados</span></p>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
          <app-footer></app-footer>
        </div>
      </div>
